import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome';
import { faHeart as favNo } from '@fortawesome/free-regular-svg-icons';
import { faHeart as favIn } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './Card.css';
/**
 * Компонент для отображения карточки участника или активности в списке
 */
const Card = ({ name, descr, icon, inFav, isHigh, onClick, onFavClick, items, stickers }) => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;

    const beforeOnFavClick = (e) => {
        e.stopPropagation();
        onFavClick();
    };

	return (
        <div
            className={`Card ${isHigh ? 'highlighted' : ''}`}
            onClick={() => onClick()}
        >
            <div className='logo'>
                <img className='logo-icon' src={icon} alt='icon'/>
                <div className='logo-text'>{name}</div>
            </div>

            <div className='info'>
                <div className='name'>
                    {name}
                </div>

                {descr &&
                <div className='descr'>
                    {descr}
                </div>}

                <ul>
                {items.filter(item => item.text.length > 0).map((item, index) => (
                    <li key={index}>
                        <div className='icon'><Icon icon={item.icon} fixedWidth/></div>
                        <div className='text'>{item.text}</div>
                    </li>))}
                </ul>

                <div className='fav' onClick={beforeOnFavClick}>
                    <div className='icon'>{<Icon icon={inFav ? favIn : favNo} fixedWidth/>}</div>
                    <div className='text'>{t(inFav ? 'favorites.infav' : 'favorites.nofav')}</div>
                </div>
            </div>

            {/* Стикеры отображаем поверх всего */}
            {stickers?.length > 0 &&
            <div className='stickers'>
                {stickers.map(item => (
                    <div
                        key={item._id}
                        className='sticker'
                        style={{ color: item.color, background: item.background }}
                    >
                        {item.text[lang]}
                    </div>
                ))}
            </div>}
        </div>
	);
};

Card.propTypes = {
    name: PropTypes.string.isRequired,
    descr: PropTypes.string,
    icon: PropTypes.string.isRequired,
    inFav: PropTypes.bool.isRequired,
    isHigh: PropTypes.bool.isRequired,
    onFavClick: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.object.isRequired,
        text: PropTypes.string.isRequired,
    })).isRequired,
    stickers: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        background: PropTypes.string.isRequired,
        text: PropTypes.shape({
            ru: PropTypes.string.isRequired,
            en: PropTypes.string.isRequired
        }).isRequired,
    })),
};

export default Card;
